<nav class="nav" [class.nav--minimal]="minimal">
  <section class="staging-badges" [hidden]="!isStagingUi && !isStagingApi">
    <a
      data-dd-action-name="navigation-v2.staging-ui-link"
      id="staging-ui"
      [href]="prodUiLink"
      class="badge bg-warning text-decoration-none"
      title="Switch to live UI"
      [hidden]="!isStagingUi"
    >
      Staging UI
    </a>
    <a
      data-dd-action-name="navigation-v2.staging-api-link"
      id="staging-api"
      href="?UseStagingApi=0"
      class="badge bg-warning text-decoration-none"
      title="Switch to live API"
      [hidden]="!isStagingApi"
    >
      Staging API
    </a>
  </section>

  @if (!hasNoOrganisation) {
    <section class="nav-fixed pb-0 org-register">
      @if (currentRegister) {
        <label>Entity & Register</label>
      }
      @if (currentOrganisation && !hasOnlyDemoRegister) {
        @if (currentRegister) {
          <div ngbDropdown>
            <button
              data-dd-action-name="navigation-v2.register-menu-button"
              type="button"
              id="register-selection"
              class="btn btn-register"
              ngbDropdownToggle
              [innerHTML]="registerDescription(currentRegister!, true)"
            ></button>

            <div
              ngbDropdownMenu
              aria-labelledby="register-selection"
              class="register-selection-menu"
            >
              <button
                data-dd-action-name="navigation-v2.current-register-button"
                type="button"
                class="active"
                ngbDropdownItem
              >
                {{ currentRegister && registerDescription(currentRegister) }}
              </button>

              @if (recentRegisters.length) {
                <div class="dropdown-divider"></div>
                <span class="small text-body-secondary">Recent Registers</span>
                @for (register of recentRegisters; track $index) {
                  <button
                    data-dd-action-name="navigation-v2.register-item-button"
                    type="button"
                    ngbDropdownItem
                    value="{{ register.id }}"
                    (click)="onUserChangedRegister(register)"
                  >
                    {{ registerDescription(register) }}
                  </button>
                }
              }

              <div class="dropdown-divider"></div>
              <button
                data-dd-action-name="navigation-v2.all-registers-button"
                type="button"
                routerLink="/organisations/{{
                  currentOrganisation.organisationId || '-'
                }}/registers"
                ngbDropdownItem
                class="text-primary"
              >
                See All Registers
              </button>

              <ng-template
                authorizeShow
                [authorizeOrganisation]="
                  OrganisationPermissionType.CreateRegister
                "
              >
                <button
                  data-dd-action-name="navigation-v2.create-register-item-button"
                  type="button"
                  (click)="openCreateRegisterModal()"
                  ngbDropdownItem
                >
                  Create New Register&hellip;
                </button>
              </ng-template>

              @if (demoRegister && !currentRegister.isDemo) {
                <div class="dropdown-divider"></div>

                <button
                  data-dd-action-name="navigation-v2.demo-register-button"
                  type="button"
                  ngbDropdownItem
                  value="{{ demoRegister.id }}"
                  class="text-guide"
                  (click)="onUserChangedRegister(demoRegister)"
                >
                  Demo Register
                </button>
              }
            </div>
          </div>
        }

        @if (!currentRegister) {
          <a
            data-dd-action-name="navigation-v2.registers-link"
            class="btn"
            routerLink="/organisations/{{
              currentOrganisation.organisationId || '-'
            }}/dashboard"
            routerLinkActive="active"
          >
            <i-lucide name="list" class="nav-icon"></i-lucide>Registers
          </a>
        }
      }

      @if (hasOnlyDemoRegister) {
        <button
          data-dd-action-name="navigation-v2.create-register-button"
          type="button"
          class="btn btn-register"
          (click)="openCreateRegisterModal()"
        >
          <i-lucide name="plus" class="nav-icon"></i-lucide>Create Register
        </button>
      }
    </section>
  }

  <section class="nav-flex">
    @if (
      primaryRegisterNavigation.length ||
      primaryOrganisationNavigation.length ||
      settingsNavigation.length
    ) {
      <div>
        @if (currentRegister) {
          @for (
            nav of primaryRegisterNavigation;
            track $index;
            let last = $last
          ) {
            @if (nav.isExpandable) {
              <button
                data-dd-action-name="navigation-v2.toggle-pools-button"
                type="button"
                class="btn"
                [class.mb-0]="last && !poolsExpanded"
                [ngbTooltip]="minimal ? nav.name : null"
                placement="end"
                (click)="togglePoolsExpanded()"
              >
                <i-lucide [name]="nav.icon" class="nav-icon"></i-lucide
                >{{ nav.name }}
                <i-lucide
                  [name]="poolsExpanded ? 'chevron-up' : 'chevron-down'"
                  class="ms-auto nav-expand-icon"
                ></i-lucide>
              </button>
              @if (poolsExpanded) {
                @for (
                  childNav of nav.children;
                  track $index;
                  let childLast = $last
                ) {
                  <a
                    data-dd-action-name="navigation-v2.pool-link"
                    class="btn pool-child"
                    [routerLink]="childNav.route"
                    [class.active]="childNav.id === currentView?.id"
                    [class.mb-0]="childLast && last"
                    [ngbTooltip]="minimal ? childNav.name : null"
                    placement="end"
                  >
                    <i-lucide [name]="childNav.icon" class="nav-icon"></i-lucide
                    >{{ childNav.name }}
                  </a>
                }
              }
            } @else {
              <ng-template
                authorizeShow
                [authorizeRegisterAny]="nav.registerPermissions"
                [authorizeFeature]="nav.feature"
                [authorizeFeatureFlag]="nav.featureFlag"
                [authorizeRegisterFeatureFlag]="nav.registerFeatureFlag"
                [authorizeRegisterFeatureFlagInverted]="
                  nav.registerFeatureFlagInverted
                "
              >
                <a
                  [attr.data-dd-action-name]="
                    `navigation-v2.nav-link.${nav.id}`
                  "
                  class="btn"
                  [routerLink]="nav.route"
                  [class.active]="nav.id === currentView?.id"
                  [class.mb-0]="last"
                  [ngbTooltip]="minimal ? nav.name : null"
                  placement="end"
                >
                  <i-lucide [name]="nav.icon" class="nav-icon"></i-lucide
                  >{{ nav.name }}
                </a>
              </ng-template>
            }
          }
          <hr class="settings-divider" />
        }

        @if (!currentRegister) {
          @for (
            nav of primaryOrganisationNavigation;
            track $index;
            let last = $last
          ) {
            <ng-template
              authorizeShow
              [authorizeOrganisationAny]="nav.organisationPermissions"
              [authorizeFeature]="nav.feature"
              [authorizeFeatureFlag]="nav.featureFlag"
            >
              <a
                [attr.data-dd-action-name]="`navigation-v2.nav-link.${nav.id}`"
                class="btn"
                [routerLink]="nav.route"
                [class.active]="nav.id === currentView?.id"
                [class.mb-0]="last"
                [ngbTooltip]="minimal ? nav.name : null"
                placement="end"
              >
                <i-lucide [name]="nav.icon" class="nav-icon"></i-lucide
                >{{ nav.name }}
              </a>
            </ng-template>
          }
          <hr class="settings-divider" />
        }

        @for (nav of settingsNavigation; track $index) {
          @if (nav.organisationPermissions) {
            <ng-template
              authorizeShow
              [authorizeOrganisationAny]="nav.organisationPermissions"
            >
              <a
                data-dd-action-name="navigation-v2.org-settings-link"
                class="btn"
                [routerLink]="orgSettingsLink"
                [class.active]="nav.id === currentView?.id"
                [ngbTooltip]="minimal ? ('Organisation Settings' | ize) : null"
                placement="end"
              >
                <i-lucide name="settings" class="nav-icon"></i-lucide>
                {{ 'Organisation' | ize }} Settings
              </a>
            </ng-template>
          }
          @if (nav.registerPermissions) {
            <ng-template
              authorizeShow
              [authorizeRegisterAny]="nav.registerPermissions"
            >
              <a
                [attr.data-dd-action-name]="`navigation-v2.nav-link.${nav.id}`"
                class="btn"
                [routerLink]="nav.route"
                [class.active]="nav.id === currentView?.id"
                [ngbTooltip]="minimal ? nav.name : null"
                placement="end"
              >
                <i-lucide [name]="nav.icon" class="nav-icon"></i-lucide
                >{{ nav.name }}
              </a>
            </ng-template>
          }
        }
      </div>
    }
  </section>

  <section class="nav-fixed bottom-nav">
    <div [class.horizontal]="!minimal">
      <div
        id="user-profile"
        class="btn mb-0"
        [ngbTooltip]="minimal ? userName : null"
        placement="end"
      >
        <ngx-avatars
          [name]="userName"
          [cornerRadius]="20"
          bgColor="#278c9c"
          fgColor="white"
          [size]="23"
          [textSizeRatio]="2.2"
          [round]="true"
          [gravatarId]="userEmail"
        >
        </ngx-avatars>
        <span class="ms-1">
          @if (currentOrganisation?.name) {
            <label>
              {{ currentOrganisation?.name }}
            </label>
          }
          <p>
            {{ userName }}
          </p>
        </span>
      </div>
      <button
        data-dd-action-name="navigation-v2.toggle-minimal-button"
        type="button"
        class="btn px-1 mb-0 d-block text-center"
        [class.w-auto]="!minimal"
        [class.ps-0]="!minimal"
        [class.mt-3]="minimal"
        [ngbTooltip]="(minimal ? 'Maximise' : 'Minimise') | ize"
        placement="end"
        (click)="minimal = !minimal"
      >
        <i-lucide
          [name]="minimal ? 'chevrons-right' : 'chevrons-left'"
          class="mx-0"
        ></i-lucide>
      </button>
    </div>
  </section>
</nav>
